import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme)=>({
    container:{
        marginTop:'25px',
        marginBottom:'25px',
        backgroundColor:theme.palette.background.paper,
        padding:'10px',
        borderRadius:'10px'
    },
    cards:{
        padding:'5% 5%',
    },
    courses:{
        padding:'5% 5%',
        color:'white',
    },
    list:{
        backgroundColor:'black'
    },
    course:{
        backgroundColor:'rgba(255,255,0,0.3)'
    },
    skill:{
        backgroundColor:'white',
        margin:'3px 5px',
        fontSize:'30px',
        color:'black',
        padding:'3px',
        display:'inline-block',
        borderRadius:'5px'
    },
    skills:{
        marginTop:'10px',
        backgroundColor:'rgba(25,255,25,0.3)'
    },
    main:{
        padding:'10px',
    }
}));
export default useStyles;